import { createElementIdSlice } from '../utils/action/createElementSlice';
export const VisualizationState = createElementIdSlice({
    elementName: 'visualization',
    initialState: {},
    reducers: {
        openGraphAccelerator(state) {
            return state;
        },
    },
});
